import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { InvestmentFinancialService } from '../../../../modules/investment/financial/investment-financial.service';
import { AccountingAccountsModel } from '../../../../modules/accounting/accounting-accounts/accounting-accounts.model';
import { ensureOk } from '../../../finance/entity-form/entity-form.utils';
import { SearchPayload } from '../../../shared/utils/table-types';
import { InvestmentListResult, requestInvestmentList } from '../../shared/investment-list.util';
import { FinancialInvestmentDeposit, FinancialInvestmentRecord } from '../models/financial-investment.model';
import { SummaryFinancialInvestmentListModel, SummaryFinancialInvestmentModel } from '../models/summary-financial-investment.model';

const LIST_ERROR = 'No se pudo cargar la lista de inversiones financieras';

@Injectable({ providedIn: 'root' })
export class FinancialInvestmentEntityService {

  constructor(private http: HttpClient, private legacy: InvestmentFinancialService) { }

  list(payload: SearchPayload): Promise<InvestmentListResult<SummaryFinancialInvestmentModel, SummaryFinancialInvestmentListModel>> {
    return requestInvestmentList<SummaryFinancialInvestmentModel, SummaryFinancialInvestmentListModel>(this.http, '/api/v2/financial-investments/list', payload, LIST_ERROR);
  }

  get(uid: string): Promise<FinancialInvestmentRecord> {
    return this.legacy.get(uid).then(record => {
      if (!record) throw new Error();
      return record as any as FinancialInvestmentRecord;
    });
  }

  create(payload: FinancialInvestmentRecord): Promise<void> {
    return this.legacy.add(payload as any).then(ensureOk);
  }

  update(uid: string, payload: FinancialInvestmentRecord): Promise<void> {
    return this.legacy.edit({ ...payload, uid } as any).then(ensureOk);
  }

  delete(uid: string): Promise<void> {
    return this.legacy.delete(uid).then(ensureOk);
  }

  accounts(): Promise<AccountingAccountsModel[]> {
    return this.legacy.accounts();
  }

  deposits(uid: string): Promise<FinancialInvestmentDeposit[]> {
    return this.legacy.depositList(uid) as any as Promise<FinancialInvestmentDeposit[]>;
  }

  createDeposit(payload: any): Promise<void> {
    return this.legacy.depositCreate(payload).then(ensureOk);
  }

  updateDeposit(payload: any): Promise<void> {
    return this.legacy.depositUpdate(payload).then(ensureOk);
  }

  deleteDeposit(uid: string): Promise<void> {
    return this.legacy.depositDelete(uid).then(ensureOk);
  }

  downloadImage(uid: string): Promise<Blob> {
    return this.legacy.downloadFileImage(uid);
  }

  downloadPdf(uid: string): Promise<Blob> {
    return this.legacy.downloadFilePDF(uid);
  }
}
